import { gql, useQuery } from "@apollo/client";
import {
  FindCampaignByIdQueryQuery,
  FindCampaignByIdQueryQueryVariables,
} from "../../../../../schemaTypes";

export const findCampaignByIdQuery = gql`
  query FindCampaignByIdQuery($id: String!) {
    findCampaignById(id: $id) {
      id
      title
      description
      question
      active
      bannerUrl
      location
      community
      campaignType
      pollOptions
      campaignLink
      startDate
      endDate
      colorCode
      views
      clickThrough
      createdAt
      adminName
      adminLevel
    }
  }
`;

export interface WithFindCampaignById {
  id: string;
  title: string;
  description: string;
  question: string;
  active: boolean;
  bannerUrl: string;
  campaignLink: string;
  startDate: string;
  endDate: string;
  views: number;
  clickThrough: number;
  pollOptions: string[];
  location: string[];
  community: string[];
  colorCode: string;
  createdAt: string;
  campaignType: string;
  loading: boolean;
  adminName: string;
  adminLevel: string;
}

interface Props {
  id: string;
  children: (data: WithFindCampaignById) => React.ReactElement | null;
}

export const FindCampaignByIdController: React.FC<Props> = ({
  id,
  children,
}) => {
  const { data, loading } = useQuery<
    FindCampaignByIdQueryQuery,
    FindCampaignByIdQueryQueryVariables
  >(findCampaignByIdQuery, {
    variables: { id },
  });

  if (!data || !data.findCampaignById) {
    return children({
      id: "",
      title: "",
      description: "",
      question: "",
      active: false,
      bannerUrl: "",
      campaignLink: "",
      startDate: "",
      endDate: "",
      views: 0,
      clickThrough: 0,
      pollOptions: [],
      location: [],
      community: [],
      colorCode: "",
      createdAt: "",
      campaignType: "",
      loading,
      adminLevel: "",
      adminName: "",
    });
  }

  const campaign = data.findCampaignById;
  const normalizeStringArray = (values?: (string | null)[] | null) =>
    values?.filter((value): value is string => typeof value === "string" && value.trim().length > 0) || [];

  return children({
    id: campaign.id || "",
    title: campaign.title || "",
    description: campaign.description || "",
    question: campaign.question || "",
    active: campaign.active || false,
    bannerUrl: campaign.bannerUrl || "",
    campaignLink: campaign.campaignLink || "",
    startDate: campaign.startDate || "",
    endDate: campaign.endDate || "",
    views: campaign.views || 0,
    clickThrough: campaign.clickThrough || 0,
    pollOptions: normalizeStringArray(campaign.pollOptions),
    location: normalizeStringArray(campaign.location),
    community: normalizeStringArray(campaign.community),
    colorCode: campaign.colorCode || "",
    createdAt: campaign.createdAt || "",
    campaignType: campaign.campaignType || "",
    loading,
    adminLevel: campaign?.adminLevel || "",
    adminName: campaign?.adminName || "",
  });
};
